// PreferenceIcons.jsx - Centralized preference icon mappings
import { HEART_ICON, THUMBS_UP_ICON, NEUTRAL_ICON, THUMBS_DOWN_ICON } from "../../constants/icons";

/**
 * Get the preference icon for a given preference value
 * @param {string} preference - The preference value ('like_a_lot', 'like', 'neutral', 'dislike', or numeric rating)
 * @returns {string} - The corresponding icon emoji or the original value if no mapping exists
 */
export const getPreferenceIcon = (preference) => {
  // Handle text-based preferences
  switch (preference) {
    case 'like_a_lot': return HEART_ICON;
    case 'like': return THUMBS_UP_ICON;
    case 'neutral': return NEUTRAL_ICON;
    case 'dislike': return THUMBS_DOWN_ICON;
    default:
      // Handle numeric ratings (1-5) - convert to text preferences
      const numericRating = parseFloat(preference);
      if (!isNaN(numericRating)) {
        if (numericRating >= 4) return HEART_ICON;      // 4-5 stars -> Love
        if (numericRating >= 3) return THUMBS_UP_ICON;  // 3 stars -> Like  
        if (numericRating >= 2) return NEUTRAL_ICON;    // 2 stars -> Neutral
        if (numericRating >= 1) return THUMBS_DOWN_ICON; // 1 star -> Dislike
      }
      // Fallback: return original value if no mapping
      return preference;
  }
};

/**
 * Get the preference label for a given preference value
 * @param {string} preference - The preference value
 * @returns {string} - The human-readable label
 */
export const getPreferenceLabel = (preference) => {
  switch (preference) {
    case 'like_a_lot': return 'Love';
    case 'like': return 'Like';
    case 'neutral': return 'Neutral';
    case 'dislike': return 'Dislike';
    default:
      // Handle numeric ratings
      const numericRating = parseFloat(preference);
      if (!isNaN(numericRating)) {
        if (numericRating >= 4) return 'Love';
        if (numericRating >= 3) return 'Like';
        if (numericRating >= 2) return 'Neutral';
        if (numericRating >= 1) return 'Dislike';
      }
      return preference;
  }
};

/**
 * All available preference options with their icons, labels, and colors
 */
export const PREFERENCE_OPTIONS = [
  { value: 'like_a_lot', icon: HEART_ICON, label: 'Love', color: '#ff6b6b' },
  { value: 'like', icon: THUMBS_UP_ICON, label: 'Like', color: '#28a745' },
  { value: 'neutral', icon: NEUTRAL_ICON, label: 'Neutral', color: '#6c757d' },
  { value: 'dislike', icon: THUMBS_DOWN_ICON, label: 'Dislike', color: '#dc3545' }
];
